import axios from 'axios'

export function createBaseService(getHeadersFunction, baseURL = import.meta.env.VITE_API_BASE) {
  if (!baseURL?.trim()) {
    throw new Error('An API base URL is required')
  }

  const service = axios.create({
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  service.interceptors.request.use(
    (config) => {
      config.headers = { ...config.headers, ...getHeadersFunction(config.data) }
      return config
    },
    (error) => Promise.reject(error),
  )

  service.interceptors.response.use(
    (response) => {
      return response.data?.meta ? response.data : response?.data?.data ?? response.data
    },
    (error) => {
      console.error(error, error?.response?.request?.responseURL)

      return Promise.reject(error)
    },
  )

  return service
}
